import React from 'react';
import { Info, Lock, X } from 'react-feather';

import Input from '../components/Input';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Select from '../components/Select';
import './Settings.css';

function Settings() {

    return (
        <div className="settings-container">
            <Header />
            <main>
                <div className="settings-area">
                    <div className="settings-item">
                        <img src="https://avatarfiles.alphacoders.com/128/128984.png" alt="avatar" />
                        <h3>Matheus José</h3>
                        <form>
                            <Input type="text" placeholder="Nome" />
                            <Input type="url" placeholder="URL Imagem de perfil" />
                            <Input type="text" placeholder="URL Imagem de fundo" />
                            <textarea placeholder="Biografia" />
                            <div className="date">
                                <Input type="text" placeholder="Dia" />
                                <Input type="text" placeholder="Mês" />
                                <Input type="text" placeholder="Ano" />
                            </div>
                            <Select />
                            <Input type="text" placeholder="Localização" />
                            <button className="settings-item-button" type="submit" >Atualizar</button>
                        </form>
                    </div>
                    <div className="settings-item">
                        <div className="settings-item-title">
                            <span><Lock width="30" height="30" /></span>
                            <h2>Alterar a senha</h2>
                            <p>Digite sua nova senha abaixo</p>
                        </div>
                        <form>
                            <Input type="password" placeholder="Senha atual" />
                            <Input type="password" placeholder="Nova senha" />
                            <button className="settings-item-button" type="submit" >Alterar</button>
                            <span>
                                <Info width={24} height={24} />
                                <p>Necessário entrar novamente</p>
                            </span>
                        </form>
                    </div>

                    <div className="settings-item">
                        <div className="settings-item-title">
                            <span style={{ color: '#ee2c0a' }}><X width="30" height="30" /></span>
                            <h2>Excluir a conta</h2>
                            <p>Confirme sua senha para exclusão</p>
                        </div>
                        <form>
                            <Input type="password" placeholder="Senha" />
                            <button className="settings-item-button btn-danger" type="submit" color="">Excluir</button>
                        </form>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    )
}

export default Settings;